import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp, faBan, faBars, faBolt,
  faCalendarAlt, faChartBar,
  faChartLine,
  faChartPie, faCheck, faCheckCircle, faCheckSquare, faChevronDown,
  faChevronLeft,
  faChevronRight, faClipboardList, faEdit, faEllipsisV,
  faEnvelopeOpenText, faEye, faFolderOpen, faGavel, faGlobe,
  faHeartbeat,
  faHourglass,
  faInbox, faInfoCircle,
  faMinus, faMinusSquare,
  faMoneyCheck, faMountain,
  faPlus, faPlusSquare, faQuestionCircle,
  faRuler,
  faRunning,
  faShoePrints, faSignOutAlt, faSpinner, faSquare,
  faStopwatch, faTachometerAlt, faThLarge, faThList, faTimes,
  faTrash, faUnlink,
  faUserCircle,
  faWindowClose,
  faCog,
} from '@fortawesome/free-solid-svg-icons';

import { faSquare as faSquareOutline, faCheckSquare as faCheckSquareOutline } from '@fortawesome/free-regular-svg-icons';

library.add([faArrowLeft, faArrowRight, faArrowUp, faArrowDown, faCalendarAlt, faChartLine,
  faChartPie, faChevronLeft, faChevronRight, faHourglass, faPlus, faRuler, faRunning, faStopwatch,
  faShoePrints, faTrash, faWindowClose, faMinus, faUserCircle, faMoneyCheck, faArchive, faHeartbeat,
  faEnvelopeOpenText, faInbox, faGavel, faSignOutAlt, faClipboardList, faTachometerAlt,
  faChartBar, faCheckCircle, faPlusSquare, faMinusSquare, faSpinner, faCheck, faBan,
  faFolderOpen, faCheckSquare, faSquare, faTimes, faUnlink, faChevronDown, faEye,
  faInfoCircle, faBolt, faQuestionCircle, faEdit, faBars, faSquareOutline, faCheckSquareOutline,
  faMountain, faThLarge, faThList, faGlobe, faEllipsisV, faCog,
]);

dom.watch();
